var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionPreferred(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1314.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Preferred",
    transform: "translate(445.000000, 1314.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1377949,0 L20.3708395,10.506 L20.3538393,10.506 L20.3708395,10.506 L28.086946,10.431 L28.1259465,10.431 C29.8879708,10.431 31.4519924,11.595 32,13.319 L23.2898798,19.743 L25.7389136,27.284 C26.3009213,29.018 25.7049131,30.926 24.2678933,32 L15.6437742,25.456 L15.6577744,25.445 L15.6437742,25.456 L9.1346844,31.176 C8.41367444,31.726 7.56066267,32 6.70665088,32 C5.86863932,32 5.03062775,31.735 4.31761791,31.204 L7.99966873,19.748 L1.70658187,15.126 C0.260561909,14.064 -0.349446511,12.161 0.199561067,10.423 L10.918709,10.505 L10.917709,10.506 L13.2507412,2.926 C13.7877486,1.184 15.3597703,0 17.1377949,0",
    id: 159
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionPreferred);
export default __webpack_public_path__ + "static/media/navigation-and-action-preferred.455033d3.svg";
export { ForwardRef as ReactComponent };